import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4056d172&scoped=true&lang=pug&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=4056d172&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056d172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4056d172')) {
      api.createRecord('4056d172', component.options)
    } else {
      api.reload('4056d172', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4056d172&scoped=true&lang=pug&", function () {
      api.rerender('4056d172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/list.vue"
export default component.exports